import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import ModalHome from '@/components/ModalHome'
import Whichloc  from '@/components/pieces/whichloc';

import DashboardHome from '@/components/DashboardHome';


import DeliveryMan from '@/components/DeliveryMan';

import CreateShop from '@/components/CreateShop';
import SettingShop from '@/components/SettingShop';
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'modalhome',
      component: ModalHome
    },
    {
      path: '/create/shop',
      name: 'createshop',
      component: CreateShop
    },
    {
      path: '/shop/:idshop/settings',
      name: 'settingshop',
      component: SettingShop

    },
    {
      path: '/locdelivery',
      name: 'whichloc',
      component: Whichloc
    },
    {
      path: '/dashboard/:idshop',
      name: 'dashboardhome',
      component: DashboardHome
    },
    {
      path: '/deliveryman/mission/:idlivreur',
      name: 'deliveryman',
      component: DeliveryMan
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js